import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

// components
import Triangles from "./Triangles";
import Panel from "./Panel";

const RootAnchorStyled = styled.div`
    position: relative;
`;

// component
export const DropDown = ({ children, className }) => {
    return (
        <RootAnchorStyled className={className}>
            <Triangles>
                <Panel>{children}</Panel>
            </Triangles>
        </RootAnchorStyled>
    );
};

// prop-types
DropDown.propTypes = {
    children: PropTypes.any,
    className: PropTypes.string
};
